var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('compWrapper',{attrs:{"title":"新品推荐","theme":"primary"}},[_c('compFormQuery',{staticClass:"margin-top-15 margin-right-15",attrs:{"formdata":_vm.getBase,"value":_vm.formData,"labelWidth":120,"placeholder":"--"}})],1),_c('vLoading',{attrs:{"size":"large","transfer":"","loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }